"use strict";

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.starts-with");

require("core-js/modules/web.dom-collections.iterator");

require("core-js/modules/web.url");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinkProperties = getLinkProperties;

// eslint-disable-next-line import/prefer-default-export
function getLinkProperties(href, rel, target, urlProp) {
  var linkProperties = {};

  if (href) {
    var _window, _window$location;

    linkProperties.rel = rel;
    linkProperties.target = target; // eslint-disable-next-line no-undef

    var url = urlProp || ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href);
    var isExternal = !href.startsWith("/") || url && href.includes(new URL(url).host);

    if (isExternal) {
      if (rel) {
        throw Error("A rel has been passed in for an external link: ".concat(rel));
      }

      if (target) {
        throw Error("A target has been passed in for an external link: ".concat(target));
      }

      linkProperties.rel = "noopener";
      linkProperties.target = "_blank";
    }
  }

  return linkProperties;
}